import { render, staticRenderFns } from "./saleOrderDispatchVendSearch.vue?vue&type=template&id=3183768d"
import script from "./saleOrderDispatchVendSearch.vue?vue&type=script&lang=js"
export * from "./saleOrderDispatchVendSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports